<template>
    <div>
        <PageTitle
                :title=titles.payment
                page="Paiement"
                v-if="showPageTitle"
        />
        <LegalNotice/>

    </div>
</template>

<script>

    import PageTitle from '@/components/common/PageTitle';
    import LegalNotice from './LegalNotice.vue';

    import {titles} from '../../utils/general/titles.js';

    export default {
        name: 'index',
        props: {
            showPageTitle: {
                type: Boolean,
                default: true
            },
            showAddButton: {
                type: Boolean,
                default: true
            }
        },
        data() {
            return {
                titles,
                org: null,
                domains: null,
                okPressed: null,
                orgDomain: null,
                packs: null
            };
        },
        components: {
            LegalNotice,
            PageTitle
        },
        methods: {
            handleOk(e) {
                this.okPressed = e;
            },
            handleDeleted(e) {
                this.okPressed = e;
            },
            getOrgDomain(e) {
                this.orgDomain = e;
            },
            getDomains(e) {
                this.domains = e;
            },
            getPacks(e) {
                this.packs = e;
            },
            getOrganisation(e) {
                this.org = e;
            }
        }
    };
</script>

<style scoped></style>
